import gql from "graphql-tag";

export const GET_CLIENTS_USERS = gql`
    query getClientsUsers {
        me {
            _id
            frontendRole {
                assets
            }
        }
        ticketUsers {
            _id
            name
            clients {
                _id
                name
            }
        }
    }
`;

export const GET_TICKET_DATA = gql`
    query getData($filter: TicketFilterInput) {
        me {
            _id
            name
            frontendRole {
                assets
            }
        }

        clients: parties(filter: { typeIn: [Client] }) {
            _id
            name
        }

        ticketUsers {
            _id
            name
            clientIds
        }

        tickets(filter: $filter) {
            _id
            title
            clientId
            client {
                _id
                name
            }
            type
            creatorId
            creator {
                name
            }
            createTimestamp
            updateTimestamp
            references {
                documentId
                collection
            }
            state {
                status
                assigneeIds
                assignees {
                    name
                }
                comment
                updateUserId
                updateUserInfo {
                    name
                }
                timestamp
            }
            previousStates {
                status
                assigneeIds
                assignees {
                    name
                }
                comment
                updateUserId
                updateUserInfo {
                    name
                }
                timestamp
            }
        }
    }
`;

export const UPSERT_TICKETS = gql`
    mutation upsertTickets($input: [TicketInput!]!) {
        upsertTickets(input: $input) {
            _id
            title
            clientId
            client {
                _id
                name
            }
            type
            creatorId
            creator {
                name
            }
            createTimestamp
            updateTimestamp
            references {
                documentId
                collection
            }
            state {
                status
                assigneeIds
                assignees {
                    name
                }
                comment
                updateUserId
                updateUserInfo {
                    name
                }
                timestamp
            }
            previousStates {
                status
                assigneeIds
                assignees {
                    name
                }
                comment
                updateUserId
                updateUserInfo {
                    name
                }
                timestamp
            }
        }
    }
`;

export const GET_TICKETS = gql`
    query getTickets($filter: TicketFilterInput) {
        tickets(filter: $filter) {
            _id
            title
            clientId
            client {
                _id
                name
            }
            type
            creatorId
            creator {
                name
            }
            createTimestamp
            updateTimestamp
            state {
                status
                assigneeIds
                assignees {
                    _id
                    name
                }
                comment
                updateUserId
                updateUserInfo {
                    name
                }
                timestamp
            }
            previousStates {
                status
                assigneeIds
                assignees {
                    name
                }
                comment
                updateUserId
                updateUserInfo {
                    name
                }
                timestamp
            }
        }
    }
`;
